import * as React from "react"


function CircleCheckOn(props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="9.5" stroke="#BDF7F7" />
      <path d="M5 9.4L8.75 13L15 7" stroke="#BDF7F7" />
    </svg>

  )
}

export default CircleCheckOn
